import { Badge, BadgeProps, HStack, Icon, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { FaComments } from 'react-icons/fa';

export interface CommentBadgeProps extends Omit<BadgeProps, 'children'> {
  count: number;
}

/**
 * A badge with a comment icon and the number of comments.
 */
export const CommentBadge: FC<CommentBadgeProps> = ({
  count,
  ...badgeProps
}) => {
  return (
    <Badge fontSize="xs" alignSelf="flex-start" {...badgeProps}>
      <HStack fontSize="xs">
        <Icon as={FaComments} boxSize={4} color="text.muted" />
        <Text fontSize="xs">{count}</Text>
      </HStack>
    </Badge>
  );
};
